import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import classNames from '../utilities/class-names';
import { tagSearchQuery } from '../utilities/tags';
import './TagList.scss';

type TagListProps = {
  className?: string;
  tags: string[];

  // Linked tags open the search bar with everything that has the tag
  linked?: boolean;

  // Tags containing any of these terms are highlighted
  highlight?: string[];
};

export function TagList({
  className,
  tags,
  linked = true,
  highlight = [],
}: TagListProps): ReactElement | null {
  if (tags.length === 0) {
    return null;
  }

  const tagClassName = (tag: string) =>
    classNames(
      'resource-tag',
      highlight.some(term => term && tag.includes(term))
        ? 'resource-tag-highlighted'
        : undefined
    );

  return (
    <span className={classNames('resource-tag-list', className)}>
      {tags.map(tag =>
        linked ? (
          <Link
            key={tag}
            className={tagClassName(tag)}
            to={{
              search: `?${new URLSearchParams({ query: tagSearchQuery(tag) })}`,
            }}
            title={`Find everything tagged "${tag}"`}
          >
            {tag}
          </Link>
        ) : (
          <span key={tag} className={tagClassName(tag)}>
            {tag}
          </span>
        )
      )}
    </span>
  );
}
